import { gql } from '@apollo/client';

export const SAMPLE_EVENTS_QUERY = 'SampleEvents';

export const GET_SAMPLE_EVENTS = gql`
  query ${SAMPLE_EVENTS_QUERY} {
    sampleEvents: sample_events(order_by: { name: desc }) {
      id
      name
      description
    }
  }
`;
